/**
 * Expose all endponts for 'resolutions' and othe misc.
 */
const ResolutionApi = api => ({
  getCustomerStatus: () => api.get(`customer-statuses`),
  getClaimTypes: () => api.get(`claim-types`),
  getServiceStatus: () => api.get(`service-statuses`),
  getFailSpecs: () => api.get(`fail-specs`),
  getActions: () => api.get(`actions`),
  getProblemTypes: () => api.get(`problem-types`),
  createResolution: (id, data) => api.post(`/alerts/${id}/resolutions`, data)
});

export default ResolutionApi;



// WEBPACK FOOTER //
// ./src/services/api/ResolutionApi.js